<style lang="less">
    .colorList_Box{
        background-color: #fff;
        width: 600px;
        min-height: 500px;
        max-height: 700px;
        height: 700px;
        margin: 0 auto;
        /* position: fixed;
        left: 50%; */
        z-index: 4;
        /* margin-left: -300px; */
        text-align: left;
        padding: 10px 20px 10px;
        border-radius: 8px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .co_title{
            // border: 1px solid red;
            height: 40px;
            line-height: 40px;
            margin-bottom: 20px;
            text-align: center;
            span{
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                font-size: 14px;
                padding: 6px 20px;
                cursor: pointer;
            }
            .isActive{
                background-color: #f36800;
                color: #fff;
                border: 1px solid #f36800;
            }
        }
        .list{
            display: flex;
            flex-wrap: wrap;
            // margin-bottom: 50px;
            label{
                display: block;
                width: 112px;
                text-align: center;
                margin-bottom: 10px;
                /* margin-right: 30px; */
                p{
                    padding: 6px;
                    cursor: pointer;
                }
                img{
                    width: 50px;
                    height: 50px;
                    cursor: pointer;
                    border-radius: 4px;
                }
            }
        }
        .all_choie_box{
            // width: 50px;
            // border: 1px solid red;
            input{
                margin-right: 3px;
                position: relative;
                top: 1px;
            }
        }
        .co_btn{
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
</style>
<template>
    <div class="colorList_Box">
        <div class="co_title">
            <!-- <span :class="{isActive : isColor}" @click="choiceSysColor">系统颜色</span>
            <span :class="{isActive : !isColor}" @click="choiceMyColor">我的颜色</span> -->
            选择绑定的颜色
        </div>
        <div class="list">
            <label :for="item.id" v-for="item in list" :key="item.id">
                <img :src="item.color_url?item.color_url+'?x-oss-process=image/resize,m_fill,h_50,w_50':item.picture[0]+'?x-oss-process=image/resize,m_fill,h_50,w_50'" alt="">
                <p>{{item.name}}</p>
                <input type="checkbox" name="" :value="item.id" v-model="pageCheckedIds[page - 1]" :id="item.id">
                <!-- <input type="radio" name="" :value="item.id" v-model="colorId" :id="item.id"> -->
            </label>
        </div>
        <div class="all_choie_box" @click="allChoice">
            <input type="checkbox" name="" id="name" v-model="checkAll"><label for="name" @click="allChoice">全选</label>
        </div>
        <div class="co_btn">
            <el-button @click="chooseColor">确认</el-button>
            <div>
                <el-button @click="previousPage" :disabled='page == 1'>上一页</el-button>
                <el-button @click="nextPage" :disabled='page == totalPage'>下一页</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:[],
    data(){
        return{
            list:[],
            saveList:[],
            checkedIds:[],
            checkAll:false,
            page: 1,
            totalPage: 1,
            pageCheckedIds:[],
            colorId:'',
            isColor: true,
            ids:[],//管理色卡ids
        }
    },
	computed:{
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
        },
        userInfo(){
          return this.$store.state.userInfo
        },
    },
    watch:{
        'pageCheckedIds':function(){
            let len = this.list.length
            let pagelen = this.pageCheckedIds[this.page - 1].length
            if(pagelen == len){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
    },
    methods:{
        /* choiceSysColor(){
            this.isColor = true
            this.page = 1
            this.getSysColorCard()
        },
        choiceMyColor(){
            this.isColor = false
            this.page = 1
            this.getMyColorCard()
        }, */
        allChoice(){
            let len = this.list.length
            let pagelen = this.pageCheckedIds[this.page - 1].length
            console.log(pagelen,len)
            if(pagelen == len){
                this.pageCheckedIds[this.page - 1] = []
            }else{
                this.pageCheckedIds[this.page - 1] = []
                this.list.forEach(item => {
                    this.pageCheckedIds[this.page - 1].push(item.id)
                })
            }
        },
        chooseColor(){
            console.log('pageCheckedIds',this.pageCheckedIds)
            let checkedId = []
            this.pageCheckedIds.forEach(item => {
                checkedId = checkedId.concat(item)
            })
           /*  let newObj = {}
            let peon = this.saveList.reduce((cur,next) => {
                newObj[next.id] ? "" : newObj[next.id] = true && cur.push(next);
                return cur;
            },[])
            let newList = peon.filter(item => {
                return checkedId.indexOf(item.id) != -1
            }) */
            // this.$emit('chooseColor',newList,this.isColor)
            console.log('选中的',checkedId)
            this.$emit('chooseColor',checkedId)
        },
        getSysColorCard(){
            let page = this.page
            // this.axios({
            //     method: 'POST',
            //     url: 'https://ggtools.thinkerx.com/erp/get_vr_bind_color',
            //     data: {
            //         uid: this.userInfo.id,
            //         supplier_id: this.supplier_id,
            //         page:page,
            //         limit:20
            //     }
            // }).then(res => {
            //     console.log('颜色列表',res.data)
            //     if(res.data.status == 1){
            //         this.list=res.data.data.comm_ls
            //         let totalPageNum = res.data.data.total
            //         this.totalPage = Math.ceil(parseInt(totalPageNum)/20)
            //         for(let i=0;i<this.totalPage;i++){
            //             this.pageCheckedIds[i] = []
            //         }
            //     }
            // }) 
            this.$post("/py/erp/get_vr_bind_color",{
                uid: this.userInfo.id,
                supplier_id: this.supplier_id,
                page:page,
                limit:20
            },res => {
                console.log('颜色列表',res)
                if(res.status == 1){
                    this.list=res.data.color_list
                    let totalPageNum = res.data.total
                    this.totalPage = Math.ceil(parseInt(totalPageNum)/20)
                    for(let i=0;i<this.totalPage;i++){
                        this.pageCheckedIds[i] = []
                    }
                }
            })

        },
        nextPage(){
            let page = ++this.page
            this.$post("/py/erp/get_vr_bind_color",{
                uid: this.userInfo.id,
                supplier_id: this.supplier_id,
                page:page,
                limit:20
            },res => {
                if(res.status == 1){
                    let list = res.data.color_list
                    this.list = list
                    list.forEach(item => {
                        this.saveList.push(item)
                    })
                    this.setCheckedAll()
                }
            })
        },
        previousPage(){
            let page = --this.page
            this.$post("/py/erp/get_vr_bind_color",{
                uid: this.userInfo.id,
                supplier_id: this.supplier_id,
                page:page,
                limit:20
            },res => {
                if(res.status == 1){
                    this.list = res.data.color_list
                    this.setCheckedAll()
                }
            })
        },
       /*  getMyColorCard(){
            this.axios({
                method: 'POST',
                url: 'https://ggtools.thinkerx.com/erp/get_private_color',
                data: {
                    uid: this.userInfo.id,
                    limit: 20,
                    page: this.page
                }
            }).then(res => {
                console.log('供应商获取个人色卡',res.data)
                let list = res.data.data.color_list
                this.list = list
                this.saveList = list
                let total = res.data.data.total
                this.totalPage = Math.ceil(parseInt(total)/20)
                console.log('总页数',this.totalPage)
                for(let i=0;i<this.totalPage;i++){
                    this.pageCheckedIds[i] = []
                }
            })
        }, */
        // 切换页码时修改全选状态
        setCheckedAll(){
            let len = this.list.length
            let pagelen = this.pageCheckedIds[this.page - 1].length
            if(pagelen == len){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        }
    },
    mounted(){
        this.getSysColorCard()
    }
}
</script>
